import { render, staticRenderFns } from "./smartmeter.vue?vue&type=template&id=2ffc806b&scoped=true&"
var script = {}
import style0 from "./smartmeter.vue?vue&type=style&index=0&id=2ffc806b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc806b",
  null
  
)

export default component.exports